define('lib/LazyEventsHelper',['require','underscore'],function (require) {

  var _ = require('underscore');

  var lazyEvents = function() {
    this.eventsCount = {};
  };

  var mixin = {
    bindLazyEvent: function(type, fn) {
      if (_.isUndefined(this.eventsCount[type]) || this.eventsCount[type] === 0) {
        fn(type);
      }

      this.eventsCount[type] = (this.eventsCount[type] || 0) + 1;
    },

    unbindLazyEvent: function(type, fn) {
      if (this.eventsCount[type] === 1) {
        fn(type);
      }

      this.eventsCount[type] = this.eventsCount[type] - 1;
    }
  };

  lazyEvents.prototype = mixin;

  return {
    initialize: function() {
      return new lazyEvents();
    },
    mixin: mixin
  };

});

